import { _WorkCategoryCreateModel } from "../interfaces/requestCreateModels/_WorkCategoryCreateModel";

export class WorkCategoryCreateModel extends _WorkCategoryCreateModel{}